import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingCard = ({ 
  plan, 
  isCurrentPlan = false, 
  isPopular = false, 
  onSelectPlan,
  loading = false 
}) => {
  const { name, price, period, description, features, buttonText, buttonVariant } = plan;

  return (
    <div className={`
      relative bg-card rounded-xl border-2 p-6 transition-all duration-200 hover:shadow-lg
      ${isPopular ? 'border-primary shadow-md' : 'border-border'}
      ${isCurrentPlan ? 'ring-2 ring-success/20 bg-success/5' : ''}
    `}>
      {/* Popular Badge */}
      {isPopular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <div className="bg-primary text-primary-foreground px-4 py-1 rounded-full text-sm font-medium">
            Most Popular
          </div>
        </div>
      )}
      {/* Current Plan Badge */}
      {isCurrentPlan && (
        <div className="absolute -top-3 right-4">
          <div className="bg-success text-success-foreground px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-1">
            <Icon name="Check" size={14} />
            <span>Current Plan</span>
          </div>
        </div>
      )}
      {/* Plan Header */}
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-foreground mb-2">{name}</h3>
        <div className="mb-3">
          <span className="text-3xl font-bold text-foreground">${price}</span>
          {period && <span className="text-muted-foreground">/{period}</span>}
        </div>
        <p className="text-muted-foreground text-sm">{description}</p>
      </div>
      {/* Features List */}
      <div className="space-y-3 mb-2">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 mt-0.5">
              <Icon 
                name={feature?.included ? "Check" : "X"} 
                size={16} 
                className={feature?.included ? "text-success" : "text-red-500"} 
              />
            </div>
            <div className="flex-1">
              <span className={`text-sm ${feature?.included ? 'text-foreground' : 'text-muted-foreground'}`}>
                {feature?.text}
              </span>
              {feature?.highlight && (
                <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-warning/10 text-warning">
                  <Icon name="Star" size={10} className="mr-1" />
                  {feature?.highlight}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* Action Button */}
      <Button
        variant={buttonVariant || 'default'}
        size="lg"
        fullWidth
        loading={loading}
        disabled={isCurrentPlan}
        onClick={() => onSelectPlan(plan)}
        iconName={isCurrentPlan ? "Check" : buttonVariant === 'outline' ? "User" : "Crown"}
        iconPosition="left"
      >
        {isCurrentPlan ? 'Current Plan' : buttonText}
      </Button>
      {/* Money Back Guarantee */}
      {name === 'Premium' && !isCurrentPlan && (
        <div className="mt-4 text-center">
          <div className="flex items-center justify-center space-x-1 text-xs text-muted-foreground">
            <Icon name="Shield" size={12} />
            <span>30-day money-back guarantee</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingCard;